import { Clock, MapPin, ShieldCheck, Euro } from "lucide-react";

const ITEMS = [
  { Icon: Clock, title: "Intervention rapide", sub: "30 à 45 minutes en moyenne", color: "text-brand" },
  { Icon: MapPin, title: "Disponible 24h/24", sub: "7 jours sur 7, jours fériés inclus", color: "text-brand" },
  { Icon: ShieldCheck, title: "Professionnels certifiés", sub: "Équipe formée et assurée", color: "text-brand" },
  { Icon: Euro, title: "Tarifs transparents", sub: "Devis gratuit, sans surprise", color: "text-brand" },
];

export default function TrustBanner() {
  return (
    <section className="bg-surface-50 border-y border-surface-200" data-testid="trust-banner">
      <div className="max-w-6xl mx-auto px-4 lg:px-6 py-8 grid grid-cols-2 lg:grid-cols-4 gap-6">
        {ITEMS.map(({ Icon, title, sub, color }) => (
          <div key={title} className="flex items-start gap-3">
            <div className="w-11 h-11 rounded-xl bg-brand-50 flex items-center justify-center shrink-0">
              <Icon size={22} className={color} />
            </div>
            <div>
              <div className="font-bold text-txt-900 text-sm leading-tight">{title}</div>
              <div className="text-xs text-txt-500 mt-0.5">{sub}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
